import WarehouseRow from './WarehouseRow'

export default WarehouseRow
